<app-progress-spinner *ngIf="!showGrid"></app-progress-spinner>
<div class="container">
  <div style="width: 100%;  margin-top: 5.9px; height: 80%;">
  <div class="label-header" style="height: 34.66px; border-radius: 3px;">
    <label class="label-headercolor" style="white-space: normal;">
      Impacted Product
    </label>
  </div>
  <div id="product" class="div-tree">
    <mat-tree *ngIf="showTree" [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree"
      role="tree" style="border-radius: 5px;">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <ul role="list">
          <li class="mat-tree-node">
            <!-- use a disabled button to provide padding for tree leaf -->
            <button aria-label="checkbox" mat-icon-button disabled></button>
            <mat-checkbox class="checklist-leaf-node checkbox-color" [disabled]="!isEditable"
              (change)="todoItemSelectionToggle($event.checked,node,$event)" [checked]="node.selected">{{node.name}}
            </mat-checkbox>
          </li>
        </ul>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <ul role="list">
          <li>
            <div class="mat-tree-node">
              <button aria-label="Arrows" mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'toggle ' + node.name">
                <img alt="Right_Arrow" *ngIf="treeControl.isExpanded(node)==false"
                  src="../assets/icons/RightArrow.svg" height="15" width="15" style="margin-bottom: 3px;">
                <img alt="Down_Arrow" *ngIf="treeControl.isExpanded(node)==true" src="../assets/icons/DownArrow.svg"
                  height="15" width="15" style="margin-bottom: 3px;">
              </button>
              <mat-checkbox [checked]="node.selected" class="checkbox-color" [disabled]="!isEditable"
                [indeterminate]="node.indeterminate && !node.selected"
                (change)="todoItemSelectionToggle($event.checked,node,$event)">{{node.name}}</mat-checkbox>
            </div>
          </li>
        </ul>
        <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="list">
          <li>
            <ng-container matTreeNodeOutlet></ng-container>
          </li>
        </ul>
      </mat-nested-tree-node>
    </mat-tree>
  </div>

</div>
</div>
<mat-dialog-actions align="end">
  <button class="button button--small" mat-dialog-close>
      Cancel</button>&nbsp;
  <button class="button button--small" cdkFocusInitial (click)="onSubmit()">
      Select</button>&nbsp;
</mat-dialog-actions>                                          